const messages = {
  country: 'bankDetail.country',
  benefits: 'bankDetail.benefits',
  offersSectionTitle: 'bankDetail.offersSectionTitle',
  offersSectionTitleProductPage: 'bankDetail.offersSectionTitleProductPage',
  selectedOfferSectionTitle: 'bankDetail.selectedOfferSectionTitle',
  offersSectionWarning: 'bankDetail.offersSectionWarning',
  bankSectionDetailsTitle: 'bankDetail.bankSectionDetailsTitle',
  bankSectionFurtherDetailsTitle: 'bankDetail.bankSectionFurtherDetailsTitle',
  securityProtectionTitle: 'bankDetail.securityProtectionTitle',
  taxAndDocTitle: 'bankDetail.taxAndDocTitle',
  taxAndDocDetails: 'bankDetail.taxAndDocDetails',
  raisinRoleTitle: 'bankDetail.raisinRoleTitle',
  raisinRoleDetails: 'bankDetail.raisinRoleDetails',
  depositAmountsNotice: 'bankDetail.depositAmountsNotice',
  protectionNotice: 'bankDetail.protectionNotice',
  roleNotice: 'bankDetail.locationNotice',
  showOtherOffers: 'bankDetail.showOtherOffers',
  showAllBankOffers: 'bankDetail.showAllBankOffers',
  backButton: 'bankDetail.backButton',
  bankProductTypeChipTerm: 'bank.productTypeChip.term',
  bankProductTypeChipOvernight: 'bank.productTypeChip.overnight',
  bankProductTypeChipNotice: 'bank.productTypeChip.notice',
  bankOffersListItemRate: 'bank.offersListItem.rate',
  bankOffersListItemDuration: 'bank.offersListItem.duration',
  bankOffersListItemNoticePeriod: 'bank.offersListItem.noticePeriod',
  bankOffersListItemDurationAndNoticePeriod: 'bank.offersListItem.durationAndNoticePeriod',
  bankOffersListItemDepositGuarantee: 'bank.offersListItem.depositGuarantee',
  bankOffersListItemDepositGuaranteeValue: 'bank.offersListItem.depositGuaranteeValue',
  bankOffersListItemCurrency: 'bank.offersListItem.currency',
  bankOffersListItemProductType: 'bank.offersListItem.productType',
  bankOffersListItemCta: 'bank.offersListItem.cta',
  bankBestOfferTitle: 'bank.bestOffer.title',
  bankBestOfferButton: 'bank.bestOffer.button',
  bankBestOfferChip: 'bank.bestOffer.chip',
  bankOfferListItemTooltip: 'bank.offersListItem.tooltip',
  bankOfferListItemTooltipExpanded: 'bank.offersListItem.hide.tooltip',
  bankListItemNoCurrency: 'bank.bankListItem.noCurrency',
  bankMetaTitle: 'bankDetail.metaTitle',
  bankMetaDescription: 'bankDetail.metaDescription',
  offerMetaTitle: 'bankDetails.offerMetaTitle',
  banksProtectionLimitTitle: 'banks.protectionLimitTitle',
  bankListItemNoActiveProducts: 'bank.bankListItem.noActiveProducts',
};
export default messages;
